import Body from "../components/Body";
import MealPlannerContainer from "../components/meal_planner/MealPlannerContainer";

export default function MealPlannerPage() {
  return (
    <Body sidebar>
      <MealPlannerContainer />
    </Body>
  );
}
